// extracted by mini-css-extract-plugin
export var aircallIframe = "_f6-3";
export var fabContainer = "_f6-5";
export var fabRinging = "_f6-6";
export var loadingOverlay = "_f6-4";
export var pulse = "_f6-7";
export var widgetContent = "_f6-2";
export var widgetPanel = "_f6-0";
export var widgetPanelExpanded = "_f6-1";